import { render, staticRenderFns } from "./OnboardingNewCompany.vue?vue&type=template&id=31e1a3cb"
import script from "./OnboardingNewCompany.vue?vue&type=script&lang=js"
export * from "./OnboardingNewCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports